import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Slide,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { FC, useContext, useEffect, useRef, useState } from "react";
import {
  AlertCircle,
  Award,
  CheckCircle,
  Circle,
  CloudDownload,
  Eye,
  X,
  ZoomIn,
} from "lucide-react";
import axios from "axios";
import toast from "react-hot-toast";

import GetAppIcon from "@mui/icons-material/GetApp";
import {
  ExampaperdetailTypes,
  ExamsDetailsTypes,
  MarksDetails,
  UserDetailsForResult,
} from "../../../interfaces/exams.interface";
import { TransitionProps } from "@mui/material/transitions";
import CustomAccordion from "../../common/CustomAccordion";

import GeneralTabs from "../../common/GeneralTabs";

import { useNavigate } from "react-router-dom";
import { baseServiceUrl, urls } from "../../../environment";
import PaperWiseMarksDistribution from "../PaperWiseMarksDistribution";
import FileUploader from "../../common/FileUploader";
import { useForm } from "react-hook-form";
import useFileUploadHandler from "../../../useFilesHandler";
import useScrutinyServices from "../../../context/useScrutinyServices";
import { FaQuestionCircle } from "react-icons/fa";
import { base64ToString, encryptWithFixedKey, generateRandomBytes } from "../../../utils";
import { capitalize } from "lodash";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ZoomModal({ isOpen, onClose, content }: any) {
  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      TransitionComponent={Transition}
      className="p-0"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-indigo-100 rounded-xl">
              <Eye className="w-5 h-5 text-indigo-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {content.type === "question" ? "Question Details" : `Option`}
              </h3>
              <p className="text-sm text-gray-500">Detailed view</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {content.image && (
            <div className="mb-6">
              <img
                src={content.image}
                alt={content.type === "question" ? "Question" : "Option"}
                className="w-full !min-h-[300px] object-contain rounded-xl border border-gray-200 shadow-sm"
              />
            </div>
          )}

          <div className="prose prose-gray max-w-none">
            <p className="text-base leading-relaxed text-gray-800 whitespace-pre-wrap">
              {content.text}
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

type ApproveScrutinyModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  selectedPaperDetails: ExampaperdetailTypes | null;
  examsDetailsTypes?: ExamsDetailsTypes | null;
  selectedAnswer: any;
  handleCloseParent: any;
  setSelectedAnswer: React.Dispatch<React.SetStateAction<any>>;
  refreshList?: () => void;
  examStatus?: string;
};
const ApproveScrutinyModal: FC<ApproveScrutinyModalProps> = ({
  isOpen,
  refreshList,
  setSelectedAnswer,
  handleClose,
  handleCloseParent,
  selectedPaperDetails,
  examsDetailsTypes,
  selectedAnswer,
  examStatus,
}) => {
  const [zoomModal, setZoomModal] = useState<{
    isOpen: boolean;
    content: {
      type: "question" | "option";
      text: string;
      image?: string;
      optionKey?: string;
    };
  }>({
    isOpen: false,
    content: { type: "question", text: "" },
  });
  const [questionPaperInfo, setQuestionPaperInfo] = useState<boolean>(true);
  const navigate = useNavigate();
  const [applicationHit, setApplicationHit] = useState<boolean>(false);
  const [approvalComment, setApprovalComment] = useState<string>("");
  const scrutinyContext = useScrutinyServices();
  const [base64Docs, setBase64Docs] = useState<any>();
  const [uploadFile, setUploadFile] = useState<any>();
  const [answerPaperInfo, setAnswerPaperInfo] = useState<boolean>(true);
  const FormHandler = useForm();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileUploadHandler = useFileUploadHandler({
    fileuploadFinallyCallback: () => {
      if (fileInputRef?.current) {
        fileInputRef.current.value = "";
      }
    },
  });

  const openZoom = (
    type: "question" | "option",
    text: string,
    image?: string,
    optionKey?: string
  ) => {
    setZoomModal({
      isOpen: true,
      content: { type, text, image, optionKey },
    });
  };

  const closeZoom = () => {
    setZoomModal({ isOpen: false, content: { type: "question", text: "" } });
  };

  console.log("selectedAnswer >>>>> ", selectedAnswer);
  const submitScrtinyHandler = () => {
    setApplicationHit(true);
    if (approvalComment?.trim()?.length === 0)
      return toast.error("Please write supporting remarks");
              const encryption_key = generateRandomBytes();

          let rawPayload = {
            encryption_key,
        exam_group_id: examsDetailsTypes?.exam_group ?? 0,
        option_id: selectedAnswer?.selected_option_id ?? 0,
        regenerate_result: false,
        remarks: approvalComment.trim(),
        supporting_docs:
          fileUploadHandler?.images?.length &&
          fileUploadHandler?.images[0]?.fileimage
            ? fileUploadHandler?.images[0]?.fileimage?.split(",")?.[1]
            : "",
      }
console.log("rawPayload >>>>> ",rawPayload);

      const payload = encryptWithFixedKey(rawPayload);
    scrutinyContext.ApplyScrutinyHandler({
      payload,
      successCallback: () => {
        setApplicationHit(false);
        handleClose();
        navigate(`/dashboard/raise-objection`);
        fileUploadHandler.clearAllFiles();
        setApprovalComment("");
        handleCloseParent?.();
        setSelectedAnswer(null);
        refreshList?.();
      },
      finallyCallback: () => {},
    });
  };

  useEffect(() => {
    if (!isOpen) {
      fileUploadHandler.clearAllFiles();
      setApprovalComment("");
      setApplicationHit(false);
    }
  }, [isOpen]);

  const getCorrectOption = (item: any) => {
    // const isCorrect =
    //   item[optionKey] === item["option_actual_ancer_id"] &&
    //   examStatus &&
    //   examStatus?.toLowerCase() === "published";

    if (item?.option_a_id === item?.option_actual_ancer_id) {
      return {
        selected_option_text: item?.option_a,
        selected_option_image: item?.option_a_img,
      };
    }

    if (item?.option_b_id === item?.option_actual_ancer_id) {
      return {
        selected_option_text: item?.option_b,
        selected_option_image: item?.option_b_img,
      };
    }
    if (item?.option_c_id === item?.option_actual_ancer_id) {
      return {
        selected_option_text: item?.option_c,
        selected_option_image: item?.option_c_img,
      };
    }
    if (item?.option_d_id === item?.option_actual_ancer_id) {
      return {
        selected_option_text: item?.option_d,
        selected_option_image: item?.option_d_img,
      };
    }
  };

  const getSelectedOption = (item: any) => {
    // const isCorrect =
    //   item[optionKey] === item["option_actual_ancer_id"] &&
    //   examStatus &&
    //   examStatus?.toLowerCase() === "published";

    if (item?.option_a_id === item?.selected_option_id) {
      return {
        selected_option_text: item?.option_a,
        selected_option_image: item?.option_a_img,
      };
    }

    if (item?.option_b_id === item?.selected_option_id) {
      return {
        selected_option_text: item?.option_b,
        selected_option_image: item?.option_b_img,
      };
    }
    if (item?.option_c_id === item?.selected_option_id) {
      return {
        selected_option_text: item?.option_c,
        selected_option_image: item?.option_c_img,
      };
    }
    if (item?.option_d_id === item?.selected_option_id) {
      return {
        selected_option_text: item?.option_d,
        selected_option_image: item?.option_d_img,
      };
    }

    console.log("====================================");
    console.log("selected option >>> ", item);
    console.log("====================================");
  };

  const getOptionClasses = (item: any, optionKey: string) => {
    const isSelected = item[optionKey] === item["selected_option_id"];
    const isCorrect =
      item[optionKey] === item["option_actual_ancer_id"] &&
      examStatus &&
      examStatus?.toLowerCase() === "published";

    if (isSelected && isCorrect) {
      return "bg-gradient-to-r from-green-100 to-emerald-100 border-green-300 text-green-900 shadow-sm";
    } else if (isSelected && !isCorrect) {
      return "bg-gradient-to-r from-blue-100 to-indigo-100 border-blue-300 text-blue-900 shadow-sm";
    } else if (!isSelected && isCorrect) {
      return "bg-gradient-to-r from-green-100 to-green-100 border-green-200 text-green-800";
    }
    return "bg-gradient-to-r from-gray-50 to-slate-50 border-gray-200 text-gray-700 hover:border-gray-300";
  };

  return (
    <Dialog
      fullWidth
      fullScreen
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={Transition}
      className="p-0 w-full max-w-screen overflow-x-hidden"
    >
      <div className="py-2  bg-blue-500 flex items-center justify-between  md:px-8 ">
        <p className="text-white text-sm lg:text-2xl font-semibold pl-2 ">
          Raise Objection in{" "}
          {examsDetailsTypes && examsDetailsTypes?.title
            ? capitalize(examsDetailsTypes.title)
            : ""}
        </p>
        <IconButton
          onClick={handleClose}
          className="text-white"
          aria-label="delete"
        >
          <CloseIcon className="text-white" />
        </IconButton>
      </div>
      <DialogContent className="!p-2 lg:p-5 w-full max-w-screen !overflow-x-hidden">
        <div className="lg:mx-4">
          {selectedAnswer ? (
            <CustomAccordion
              title={"Selected Answer For Objection"}
              isExpanded={answerPaperInfo}
              setExpanded={setAnswerPaperInfo}
              secondary
              // highlightColor={"bg-[#c026d3]"}
            >
              <div
                key={selectedAnswer.qid}
                className="bg-white/80 backdrop-blur-sm !my-4  cursor-pointer rounded-2xl  border !border-gray-300 border-white/20 hover:shadow-xl transition-all duration-300"
              >
                {/* Compact item Header */}
                <div className="p-4 border-b border-gray-100/50">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      {/* <div
              className={`px-3 py-1 rounded-full text-xs font-medium ${
                item.correct_flag
                  ? "bg-gradient-to-r from-green-100 to-emerald-100 text-green-700 border border-green-200"
                  : "bg-gradient-to-r from-red-100 to-rose-100 text-red-700 border border-red-200"
              }`}
            >
              {item.correct_flag ? "✓ Correct" : "✗ Incorrect"}
            </div> */}
                    </div>

                    <div className="flex items-center space-x-4 text-xs">
                      {selectedAnswer.question_marks ? (
                        <div className="flex items-center space-x-2 bg-amber-600 px-3  rounded-sm py-1 ">
                          <Award className="w-4 h-4 text-white" />
                          <p className="text-white text-sm">Actual Marks : </p>
                          <span className="font-medium text-white">
                            {selectedAnswer.question_marks}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      {selectedAnswer.question_negative_mark ? (
                        <div className="flex items-center space-x-2 bg-red-500 px-3 rounded-sm py-1">
                          <AlertCircle className="w-4 h-4 text-white" />
                          <p className="text-white text-sm">
                            Negative Marks :{" "}
                          </p>
                          <span className="font-medium text-white">
                            {selectedAnswer.question_negative_mark}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  {selectedAnswer.obtain_marks ? (
                    <div className="flex mt-2 mb-1 ">
                      <div
                        className={`flex mt-2  text-xs px-2 py-1 font-semibold text-white rounded-sm ${
                          selectedAnswer.obtain_marks?.startsWith("-")
                            ? `bg-red-600`
                            : `bg-green-500`
                        }`}
                      >
                        Obtained Marks : {selectedAnswer.obtain_marks}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                {/* Question Content */}
                <div className="p-4">
                  {/* Question with Zoom */}
                  <div className="mb-4">
                    <div className="flex flex-col gap-y-4">
                      {selectedAnswer.question_text?.trim()?.length ? (
                        <div className="flex-1">
                          <div className="flex items-start space-x-3 px-2  ">
                            <div className="w-5 h-5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center !text-white text-sm font-bold">
                              <FaQuestionCircle
                                className="text-white"
                                size={15}
                              />
                            </div>
                            <p className="text-sm font-medium text-gray-900 leading-relaxed ">
                              {selectedAnswer.question_text}
                            </p>

                            <button
                              onClick={() =>
                                openZoom(
                                  "question",
                                  selectedAnswer.question_text,
                                  selectedAnswer.question_img
                                )
                              }
                              className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-100 rounded-lg"
                              title="View full question"
                            >
                              <ZoomIn className="w-4 h-4 text-gray-500" />
                            </button>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      {selectedAnswer.question_img && (
                        <div className="w-full flex items-center gap-x-4">
                          <div className="w-5 h-5 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center !text-white text-sm font-bold">
                            <FaQuestionCircle
                              className="text-white"
                              size={15}
                            />
                          </div>
                          <img
                            // src={item.question_image_url}
                            src={base64ToString(
                              `${selectedAnswer.question_img}`
                            )}
                            alt="Question"
                            className="!w-full !h-[100px] object-contain rounded-lg border border-gray-200 cursor-pointer hover:shadow-md transition-shadow"
                            onClick={() =>
                              openZoom(
                                "question",
                                selectedAnswer.question_text,
                                base64ToString(`${selectedAnswer.question_img}`)
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3">
                    {selectedAnswer?.option_a ||
                    selectedAnswer?.option_a_img ? (
                      <div
                        className={`p-3 rounded-xl border transition-all duration-200 group    ${getOptionClasses(
                          selectedAnswer,
                          "option_a_id"
                        )}`}
                      >
                        <div className="flex items-center gap-x-4">
                          {selectedAnswer?.option_a?.trim()?.length ? (
                            <div className="flex items-center space-x-2 flex-1 min-w-0">
                              <span className="text-sm text-wrap !text-black">
                                {selectedAnswer?.option_a}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="flex items-center space-x-2  cursor-pointer ">
                            {selectedAnswer.option_a_img && (
                              <>
                                <img
                                  src={`${base64ToString(
                                    `${selectedAnswer.option_a_img}`
                                  )}`}
                                  alt={`Option image`}
                                  className="!w-full !h-16 object-contain rounded border"
                                />
                                <ZoomIn
                                  className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                  onClick={() =>
                                    openZoom(
                                      "option",
                                      selectedAnswer?.option_a,
                                      `${base64ToString(
                                        `${selectedAnswer.option_a_img}`
                                      )}`,
                                      "option_a_img"
                                    )
                                  }
                                />
                              </>
                            )}

                            {/* {getOptionIcon(item, optionKey)} */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {selectedAnswer?.option_b ||
                    selectedAnswer?.option_b_img ? (
                      <div
                        className={`p-3 rounded-xl border transition-all duration-200 group   ${getOptionClasses(
                          selectedAnswer,
                          "option_b_id"
                        )}`}
                        // onClick={() =>
                        //   openZoom(
                        //     "option",
                        //     optionData.text,
                        //     optionData.image_url,
                        //     optionKey
                        //   )
                        // }
                      >
                        <div className="flex items-center gap-x-4">
                          {selectedAnswer?.option_b?.trim()?.length ? (
                            <div className="flex items-center space-x-2 flex-1 min-w-0">
                              <span className="text-sm text-wrap">
                                {selectedAnswer?.option_b}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="flex items-center space-x-2 flex-shrink-0 cursor-pointer">
                            {selectedAnswer.option_b_img ? (
                              <>
                                <img
                                  src={`${base64ToString(
                                    `${selectedAnswer.option_b_img}`
                                  )}`}
                                  alt={`Option image`}
                                  className="!w-[80%] !h-16 object-contain rounded border"
                                />
                                <ZoomIn
                                  className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                  onClick={() =>
                                    openZoom(
                                      "option",
                                      selectedAnswer?.option_b,
                                      `${base64ToString(
                                        `${selectedAnswer.option_b_img}`
                                      )}`,
                                      "option_b_img"
                                    )
                                  }
                                />
                              </>
                            ) : (
                              <></>
                            )}

                            {/* {getOptionIcon(item, optionKey)} */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {selectedAnswer?.option_c ||
                    selectedAnswer?.option_c_img ? (
                      <div
                        className={`p-3 rounded-xl border transition-all duration-200 group   ${getOptionClasses(
                          selectedAnswer,
                          "option_c_id"
                        )}`}
                        // onClick={() =>
                        //   openZoom(
                        //     "option",
                        //     optionData.text,
                        //     optionData.image_url,
                        //     optionKey
                        //   )
                        // }
                      >
                        <div className="flex items-center gap-x-4">
                          {selectedAnswer?.option_c?.trim()?.length ? (
                            <div className="flex items-center space-x-2 flex-1 min-w-0">
                              <span className="text-sm text-wrap">
                                {selectedAnswer?.option_c}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="flex items-center space-x-2 flex-shrink-0 cursor-pointer">
                            {selectedAnswer.option_c_img ? (
                              <>
                                <img
                                  src={`${base64ToString(
                                    `${selectedAnswer.option_c_img}`
                                  )}`}
                                  alt={`Option image`}
                                  className="!w-full !h-16 object-contain rounded border"
                                />
                                <ZoomIn
                                  className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                  onClick={() =>
                                    openZoom(
                                      "option",
                                      selectedAnswer?.option_c,
                                      `${base64ToString(
                                        `${selectedAnswer.option_c_img}`
                                      )}`,
                                      "option_c_img"
                                    )
                                  }
                                />
                              </>
                            ) : (
                              <></>
                            )}

                            {/* {getOptionIcon(item, optionKey)} */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {selectedAnswer?.option_d ||
                    selectedAnswer?.option_d_img ? (
                      <div
                        className={`p-3 rounded-xl border transition-all duration-200 group    ${getOptionClasses(
                          selectedAnswer,
                          "option_d_id"
                        )}`}
                        // onClick={() =>
                        //   openZoom(
                        //     "option",
                        //     optionData.text,
                        //     optionData.image_url,
                        //     optionKey
                        //   )
                        // }
                      >
                        <div className="flex items-center gap-x-4">
                          {selectedAnswer?.option_d?.trim()?.length ? (
                            <div className="flex items-center space-x-2 flex-1 min-w-0">
                              <span className="text-sm text-wrap">
                                {selectedAnswer?.option_d}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="flex items-center space-x-2 flex-shrink-0 cursor-pointer">
                            {selectedAnswer.option_d_img ? (
                              <>
                                <img
                                  src={`${base64ToString(
                                    `${selectedAnswer.option_d_img}`
                                  )}`}
                                  alt={`Option image`}
                                  className="!w-full !h-16 object-contain rounded border"
                                />
                                <ZoomIn
                                  className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                  onClick={() =>
                                    openZoom(
                                      "option",
                                      selectedAnswer?.option_d,
                                      `${base64ToString(
                                        `${selectedAnswer.option_d_img}`
                                      )}`,
                                      "option_d_img"
                                    )
                                  }
                                />
                              </>
                            ) : (
                              <></>
                            )}

                            {/* {getOptionIcon(item, optionKey)} */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  {/* Compac
          }t Answer Summary */}
                  <div className="flex items-center justify-between text-xs bg-gray-50/50 rounded-xl p-3">
                    <div className="flex flex-col gap-y-4">
                      {getSelectedOption(selectedAnswer) ? (
                        <div className="flex flex-col gap-y-3">
                          <div className="flex items-center gap-x-4">
                            <Circle className="w-3 h-3 text-blue-600 fill-current" />
                            <p className="text-md text-blue-600">
                              Selected Answer
                            </p>
                          </div>

                          <div
                            className={`p-3 rounded-xl border transition-all duration-200 group   `}
                            // onClick={() =>
                            //   openZoom(
                            //     "option",
                            //     optionData.text,
                            //     optionData.image_url,
                            //     optionKey
                            //   )
                            // }
                          >
                            <div className="flex items-center gap-x-4">
                              {getSelectedOption(
                                selectedAnswer
                              )?.selected_option_text?.trim()?.length ? (
                                <div className="flex items-center space-x-2 flex-1 min-w-0">
                                  <span className="text-sm text-wrap">
                                    {
                                      getSelectedOption(selectedAnswer)
                                        ?.selected_option_text
                                    }
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div className="flex items-center space-x-2 flex-shrink-0 cursor-pointer">
                                {getSelectedOption(selectedAnswer)
                                  ?.selected_option_image ? (
                                  <>
                                    <img
                                      src={`${base64ToString(
                                        `${
                                          getSelectedOption(selectedAnswer)
                                            ?.selected_option_image
                                        }`
                                      )}`}
                                      alt={`Option image`}
                                      className="!w-full !h-16 object-contain rounded border"
                                    />
                                    <ZoomIn
                                      className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                      onClick={() =>
                                        openZoom(
                                          "option",
                                          getSelectedOption(selectedAnswer)
                                            ?.selected_option_text,
                                          `${base64ToString(
                                            `${
                                              getSelectedOption(selectedAnswer)
                                                ?.selected_option_image
                                            }`
                                          )}`,
                                          "option_c_img"
                                        )
                                      }
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}

                                {/* {getOptionIcon(item, optionKey)} */}
                              </div>
                            </div>
                          </div>

                          <div></div>

                          {/* <span className="text-gray-600">
                Selected:{" "}
                <span className="font-semibold text-blue-700">
                  {item.selected_options_value}
                </span>
              </span> */}
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="flex flex-col gap-y-3">
                        <div className="flex items-center gap-x-4">
                          <CheckCircle className="w-3 h-3 text-green-600 fill-current" />
                          <p className="text-md font-semibold text-green-600">
                            Correct Answer
                          </p>
                        </div>
                        {getCorrectOption(selectedAnswer) ? (
                          <div
                            className={`p-3 rounded-xl border transition-all duration-200 group   `}
                            // onClick={() =>
                            //   openZoom(
                            //     "option",
                            //     optionData.text,
                            //     optionData.image_url,
                            //     optionKey
                            //   )
                            // }
                          >
                            <div className="flex items-center gap-x-4">
                              {getCorrectOption(
                                selectedAnswer
                              )?.selected_option_text?.trim()?.length ? (
                                <div className="flex items-center space-x-2 flex-1 min-w-0">
                                  <span className="text-sm text-wrap">
                                    {
                                      getCorrectOption(selectedAnswer)
                                        ?.selected_option_text
                                    }
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div className="flex items-center space-x-2 flex-shrink-0 cursor-pointer">
                                {getCorrectOption(selectedAnswer)
                                  ?.selected_option_image ? (
                                  <>
                                    <img
                                      src={`${base64ToString(
                                        `${
                                          getCorrectOption(selectedAnswer)
                                            ?.selected_option_image
                                        }`
                                      )}`}
                                      alt={`Option image`}
                                      className="!w-full !h-16 object-contain rounded border"
                                    />
                                    <ZoomIn
                                      className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                                      onClick={() =>
                                        openZoom(
                                          "option",
                                          getCorrectOption(selectedAnswer)
                                            ?.selected_option_text,
                                          `${base64ToString(
                                            `${
                                              getCorrectOption(selectedAnswer)
                                                ?.selected_option_image
                                            }`
                                          )}`,
                                          "option_c_img"
                                        )
                                      }
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}

                                {/* {getOptionIcon(item, optionKey)} */}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div></div>

                        {/* <span className="text-gray-600">
                Selected:{" "}
                <span className="font-semibold text-blue-700">
                  {item.selected_options_value}
                </span>
              </span> */}
                      </div>
                    </div>
                  </div>
                </div>
                <ZoomModal
                  isOpen={zoomModal.isOpen}
                  onClose={closeZoom}
                  content={zoomModal.content}
                />
              </div>
            </CustomAccordion>
          ) : (
            <></>
          )}
          <div className="w-full h-[2px] bg-gray-200 mt-8 mb-4"></div>
          <div className="mt-4 mx-auto w-full">
            <Grid container>
              <Grid item xs={12} md={12}>
                <div className="mt-5">
                  <div className="flex items-center gap-x-3">
                    <Typography className="formLabel">
                      Supporting Remarks
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </div>
                  <TextField
                    id="outlined-textarea"
                    label={`Write your Supporting remarks `}
                    value={approvalComment}
                    placeholder="Placeholder"
                    multiline
                    minRows={3}
                    onChange={(event) => setApprovalComment(event.target.value)}
                    required
                    error={approvalComment === "" && applicationHit}
                    helperText={
                      approvalComment === "" && applicationHit
                        ? "This field is required"
                        : ""
                    }
                    sx={{ width: "100%" }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={12} lg={12} mt={4}>
                <Typography className="formLabel">
                  Upload Your Supporting Document (optional)
                  {/* <span style={{ color: "red" }}>*</span> */}
                </Typography>
                <Box sx={{ width: "100%", height: "95%" }}>
                  <FileUploader
                    control={FormHandler.control}
                    rules={{}}
                    inputRef={fileUploadHandler.multiFormFileRef}
                    name={"file"}
                    selectedFiles={fileUploadHandler.images}
                    errors={FormHandler.formState.errors}
                    fileUploadEvent={(files: any | Array<any>) => {
                      const file: any = files?.[0];
                      if (file && file.type === "application/pdf") {
                        setUploadFile(files?.[0]);

                        fileUploadHandler.FileUploadSuccessHandler(file);
                      } else {
                        toast.error("Please upload a valid .pdf file");
                      }
                    }}
                    label={"Upload File"}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={12} mt={2} mb={5}>
                <div className="flex items-center justify-end gap-x-4">
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={() => handleClose()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    onClick={() => submitScrtinyHandler()}
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveScrutinyModal;
